import { yupResolver } from "@hookform/resolvers/yup";
import LoginUI from "components/Login/Login.presenter";
import { LoginFormData, loginSchema } from "components/Login/Login.schema";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useLogIn } from "src/hooks/api/auth/useLogin";
import { logout } from "src/service/sessions";

const PromotionCardLogin = () => {
  const [isShowFindPassword, setIsShowFindPassword] = useState<boolean>(false);
  const [invalidUser, setInvalidUser] = useState<boolean>(false);
  // 로그인 폼 관리
  const loginForm = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      userId: localStorage?.getItem("potal.wrapsodyeco.com_userId") ?? "",
      password: "",
      isIdSave: localStorage.getItem("potal.wrapsodyeco.com_userId")
        ? true
        : false,
    },
    mode: "onChange",
  });
  const { setError } = loginForm;
  const { userId, password, isIdSave } = loginForm.watch();
  const loginPossible = loginForm.formState.isValid && !!userId && !!password;
  const { mutateLogin } = useLogIn({
    type: "PROMOTION_CARD",
    setInvalidUser,
    setError,
  });
  // 로그인 폼 제출 핸들러
  const onLoginSubmit = async (data: LoginFormData) => {
    try {
      await logout(true);
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    mutateLogin({ userId: data.userId, password: data.password });
  };
  const goBackLogin = () => {
    setIsShowFindPassword(false);
  };

  const goFindPassword = () => {
    setIsShowFindPassword(true);
  };
  // ID 저장 체크박스 핸들러
  const handleChangeIdSave = () => {
    const currentValue = loginForm.getValues("isIdSave");
    const newValue = !currentValue;
    loginForm.setValue("isIdSave", newValue);

    const userId = loginForm.getValues("userId");
    if (newValue && userId) {
      localStorage.setItem("potal.wrapsodyeco.com_userId", userId);
    } else {
      localStorage.removeItem("potal.wrapsodyeco.com_userId");
    }
  };
  return (
    <FormProvider {...loginForm}>
      <LoginUI
        // 폼 데이터
        userId={userId}
        password={password}
        isIdSave={isIdSave}
        // 상태
        isShowFindPassword={isShowFindPassword}
        loginPossible={loginPossible}
        invalidUser={invalidUser}
        // 폼 관련
        loginForm={loginForm}
        onLoginSubmit={onLoginSubmit}
        // 핸들러
        handleChangeIdSave={handleChangeIdSave}
        goBackLogin={goBackLogin}
        goFindPassword={goFindPassword}
      />
    </FormProvider>
  );
};

export default PromotionCardLogin;
